import { POPULAR_TREATMENT_TERMS } from '../../useCases/popularTreatment/constants'

export const sortPopularTreatmentTypes = (cardA, cardB) => {
  const cardAIndex = POPULAR_TREATMENT_TERMS.findIndex(
    (term) => term.label === cardA.label
  )
  const cardBIndex = POPULAR_TREATMENT_TERMS.findIndex(
    (term) => term.label === cardB.label
  )

  return cardAIndex - cardBIndex
}
